import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

export const TermsPage = () => {
  return (
    <main className="min-h-screen pt-32 pb-20" data-testid="terms-page">
      <SEO title="ÁSZF" description="Az Akadémia Plusz 2.0 Kft. Általános Szerződési Feltételei." path="/aszf" />
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-8">
            Általános Szerződési Feltételek
          </h1>

          <div className="glass-card p-8 md:p-12 space-y-12 text-white/70 leading-relaxed">

            {/* 1. A szolgáltató adatai */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                1. A szolgáltató adatai
              </h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <p className="text-white/80 font-medium">Szolgáltató neve:</p>
                  <p className="text-white font-semibold">Akadémia Plusz 2.0 Kft.</p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Székhely:</p>
                  <p className="text-white font-semibold">1027 Budapest, Kapás utca 6–12</p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Cégjegyzékszám:</p>
                  <p className="text-white font-semibold">01-09-322887</p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Adószám:</p>
                  <p className="text-white font-semibold">26300575-2-41</p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Telefonszám:</p>
                  <p><a href="tel:+36705188091" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">+36 70 518 8091</a></p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">E-mail:</p>
                  <p><a href="mailto:akademia@dh.hu" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">akademia@dh.hu</a></p>
                </div>
              </div>
              <p className="mt-6">
                A jelen Általános Szerződési Feltételek (a továbbiakban: <strong className="text-white">ÁSZF</strong>) szabályozzák az Akadémia Plusz 2.0 Kft. által szervezett képzések és tréningek igénybevételének feltételeit.
              </p>
            </section>

            {/* 2. Az ÁSZF hatálya */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                2. Az ÁSZF hatálya
              </h2>
              <p className="mb-3">
                Az ÁSZF hatálya kiterjed minden olyan természetes személyre vagy gazdálkodó szervezetre (a továbbiakban: <strong className="text-white">résztvevő</strong>), aki
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>az Akadémia weboldalán keresztül jelentkezik képzésre, vagy</li>
                <li>az Akadémia által szervezett képzésen részt vesz.</li>
              </ul>
              <p className="mt-3">
                A weboldalon történő jelentkezéssel a résztvevő elfogadja a jelen ÁSZF rendelkezéseit.
              </p>
            </section>

            {/* 3. A szolgáltatás jellege */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                3. A szolgáltatás jellege
              </h2>
              <p className="mb-3">
                Az Akadémia Plusz 2.0 Kft. készségfejlesztő képzéseket és tréningeket szervez, különösen az alábbi témákban:
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>kommunikációs készségek</li>
                <li>tárgyalástechnika</li>
                <li>stresszkezelés</li>
                <li>személyiségfejlesztés</li>
                <li>értékesítési és üzleti készségek</li>
                <li>ingatlanszakmai képzések</li>
              </ul>
              <p className="mt-3">
                A képzések <strong className="text-white">kizárólag személyes jelenléttel, helyszíni formában kerülnek megtartásra</strong>.
              </p>
            </section>

            {/* 4. Jelentkezés folyamata */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                4. Jelentkezés folyamata
              </h2>
              <p className="mb-3">
                A képzésekre történő jelentkezés a weboldalon keresztül vagy egyéb kapcsolattartási módon történhet.
              </p>
              <p className="mb-3">
                A jelentkezés során a résztvevő megadja a szükséges adatokat, amelyek alapján a szolgáltató visszaigazolást küld.
              </p>
              <p>
                A jelentkezés a szolgáltató visszaigazolásával válik érvényessé.
              </p>
            </section>

            {/* 5. Díjfizetés */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                5. Díjfizetés
              </h2>
              <p className="mb-3">
                A képzések díja a képzés leírásánál vagy a szolgáltató által küldött tájékoztatóban kerül feltüntetésre.
              </p>
              <p className="mb-3">
                A képzési díj megfizetése <strong className="text-white">banki átutalással történik</strong> a szolgáltató által kiállított számla alapján.
              </p>
              <p className="mb-3">
                A fizetési határidőt a kiállított számla tartalmazza.
              </p>
              <p>
                A képzésen való részvétel feltétele a képzési díj határidőben történő megfizetése.
              </p>
            </section>

            {/* 6. A képzések megszervezése */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                6. A képzések megszervezése
              </h2>
              <p className="mb-3">
                A képzések meghatározott időpontban és helyszínen kerülnek megrendezésre.
              </p>
              <p className="mb-3">
                A szolgáltató fenntartja a jogot arra, hogy <strong className="text-white">alacsony jelentkezőszám vagy egyéb indokolt körülmény esetén a képzés időpontját módosítsa vagy áthelyezze</strong>.
              </p>
              <p>
                Ilyen esetben a résztvevőket a szolgáltató értesíti az új időpontról.
              </p>
            </section>

            {/* 7. Lemondás és részvétel */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                7. Lemondás és részvétel
              </h2>
              <p className="mb-3">
                A képzésen való részvétel akadályoztatása esetén a résztvevő köteles erről a szolgáltatót haladéktalanul értesíteni.
              </p>
              <p>
                A képzésről való lemondás feltételeit a szolgáltató az adott képzésre vonatkozó tájékoztatás során egyedileg határozhatja meg.
              </p>
            </section>

            {/* 8. Szellemi tulajdon */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                8. Szellemi tulajdon
              </h2>
              <p className="mb-3">
                Az Akadémia által a képzések során használt minden oktatási anyag, prezentáció, módszertan és egyéb tartalom a szolgáltató vagy az oktatók szellemi tulajdonát képezi.
              </p>
              <p className="mb-2">Az oktatási anyagok</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>nem másolhatók</li>
                <li>nem terjeszthetők</li>
                <li>nem használhatók fel kereskedelmi célra</li>
              </ul>
              <p className="mt-2">
                a szolgáltató előzetes írásbeli engedélye nélkül.
              </p>
            </section>

            {/* 9. Felelősség */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                9. Felelősség
              </h2>
              <p className="mb-3">
                A képzéseken való részvétel önkéntes.
              </p>
              <p>
                A szolgáltató nem vállal felelősséget olyan károkért, amelyek a résztvevő saját döntéseiből vagy a képzésen megszerzett információk alkalmazásából erednek.
              </p>
            </section>

            {/* 10. Céges tréningek */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                10. Céges tréningek
              </h2>
              <p className="mb-3">
                A vállalatok számára szervezett tréningek és fejlesztési programok <strong className="text-white">egyedi ajánlat és külön megállapodás alapján</strong> kerülnek megszervezésre.
              </p>
              <p>
                Az ilyen tréningekre a jelen ÁSZF rendelkezései mellett az egyedi szerződés feltételei is irányadóak.
              </p>
            </section>

            {/* 11. Adatkezelés */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                11. Adatkezelés
              </h2>
              <p className="mb-3">
                A szolgáltató a jelentkezés során megadott személyes adatokat az <strong className="text-white">Adatkezelési tájékoztatóban</strong> foglaltak szerint kezeli.
              </p>
              <p>
                Az adatkezelési tájékoztató a weboldalon külön dokumentumként érhető el:{' '}
                <Link to="/adatvedelem" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-medium">
                  Adatkezelési tájékoztató
                </Link>
              </p>
            </section>

            {/* 12. Záró rendelkezések */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                12. Záró rendelkezések
              </h2>
              <p className="mb-3">
                A jelen ÁSZF-re a magyar jog rendelkezései irányadóak.
              </p>
              <p className="mb-3">
                Az esetleges jogviták rendezésére a felek elsősorban békés úton törekednek.
              </p>
              <p>
                Amennyiben ez nem vezet eredményre, a felek a hatáskörrel rendelkező magyar bíróság illetékességét fogadják el.
              </p>
            </section>

          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default TermsPage;
